
        import '/home/builduser/work/c1dd1064fea009a6/santa-editor/packages/appManager/components/Section/Section.scss.css.virtualfile';
        module.exports = {"section":"_section_180ae_1","heading":"_heading_180ae_4","link":"_link_180ae_7","content":"_content_180ae_10"};